import { IProjectPositionSkill } from '../interfaces/projectPositionSkill';

export const getSkillsInStringArr = (skills: string[] | IProjectPositionSkill[]): string[] => {
  return typeof skills[0] === 'string' ? skills as string[] : (skills as IProjectPositionSkill[]).map(s => s.skill);
};